'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "className", "classNameBase", "selected"];
import { useEffect } from 'react';
import { cn } from "../utils";
import { useDropdownContext } from "./context";
import { DropdownBaseItem } from "./DropdownBaseItem";
import { DropdownBaseList } from "./DropdownBaseList";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated Use TextsDropdown or AsyncTextsDropdown instead, unless you need specific functionality not yet supported by these components.
 */
export var DropdownTextList = function DropdownTextList(_ref) {
  var items = _ref.items,
    className = _ref.className,
    classNameBase = _ref.classNameBase,
    selected = _ref.selected,
    itemProps = _objectWithoutProperties(_ref, _excluded);
  var _useDropdownContext = useDropdownContext(),
    values = _useDropdownContext.values,
    setItems = _useDropdownContext.setItems;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    setItems(items.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        type: 'text'
      });
    }));
  }, [items]);
  return /*#__PURE__*/_jsx(DropdownBaseList, {
    selected: selected,
    className: classNameBase,
    children: items.map(function (item) {
      var isSelected = values.includes(item.value);
      return /*#__PURE__*/_jsx(DropdownBaseItem, _objectSpread(_objectSpread({
        value: item.value,
        searchKey: item.label,
        isSelected: isSelected,
        disabled: item.disabled,
        className: cn(isSelected && 'tw-bg-neutral-light-300 dark:tw-bg-neutral-dark-600', className)
      }, itemProps), {}, {
        children: item.label
      }), item.value);
    })
  });
};